import {
    ATTEMPT_FETCH_EXERCISES,
    ATTEMPT_ADD_MAXABLE_EXERCISE,
} from 'shared_redux/actions';

export const fetchExercises = () => ({ type: ATTEMPT_FETCH_EXERCISES, includeParentExerciseLinks: true });

export const addMaxableExercise = (exerciseId) => ({ type: ATTEMPT_ADD_MAXABLE_EXERCISE, exerciseId });
